module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Notification_PeriodicalUpdater', {
		configure: function(options) {
			this.registerOptions('', {
				enable: true
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this.setOption('enable', !fox.cookie.get('disableNotifying'));

			this.callParent('init', arguments);
		},

		running: function() {
			// debugger;
			if (this.getOption('enable')) {
				this.startUpdate();
			};
		},

		todo: function() {
			var lastId = fox.cookie.get('notifyFrom');

			this.rwom1('@parent #notificationListData').setTransitParameter('notifyFrom', lastId).load();				
		}

	}, 'PeriodicalUpdater');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/notification/notificationUpdater.js
// module id = 871
// module chunks = 4